import { useApi } from "@/hooks/useApi";
import type { ClubInfo } from "@/lib/types";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import BizmapPreview from "./components/BizmapPreview";
import CardSection from "./components/CardSection";
import AttendSection from "./components/AttendSection";
import PromoSection from "./components/PromoSection";
import NoticeSection from "./components/NoticeSection";
import GallerySection from "./components/GallerySection";
import FreeSection from "./components/FreeSection";
import ClubAccountSection from "./components/ClubAccountSection";
import PopupModal from "./components/PopupModal";

export default function Home() {
  const { data: club, loading: clubLoading } = useApi<ClubInfo>("club.php");

  return (
    <>
      <Hero club={club} />
      <IntroSection club={club} loading={clubLoading} />
      <CardSection />
      <BizmapPreview />
      <AttendSection />
      <PromoSection />
      <GallerySection />
      <FreeSection />
      <NoticeSection />
      <ClubAccountSection club={club} />
      <PopupModal popups={club?.popup ?? []} />
    </>
  );
}